import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Toast } from '@treelab/panda';

import TemplatePage from './template';
import { localeMessages } from '../lib/localization';
import { IRootState, IDispatch } from '../modules/stores';
import { IURLParams, Locale } from '../modules/core/types';
import { initializePandaPicker } from '../lib/pandaPicker';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

interface IProps extends IConnectProps {
  urlParams: IURLParams;
}

const Context = styled.div`
  & > span {
    color: #fff;
  }
`;

class App extends React.PureComponent<IProps> {
  public async componentDidMount() {
    const { urlParams } = this.props;
    this.props.setCurrentBlock(urlParams.blockId);
    this.props.setCurrentWorkspace(urlParams.workspaceId);
    this.props.setLocale(urlParams.locale || Locale.ZH);
    this.props.setIsExpand(urlParams.isExpand === 'true');
    this.props.setCanEdit(urlParams.hasPermission === 'true');

    // get the user ID from the provided sessionId
    const userId = urlParams.meId;
    this.props.setMeId({ id: userId });

    if (!!urlParams.isExpand) initializePandaPicker();
  }

  render() {
    const { urlParams, toast } = this.props;

    const locale = urlParams.locale || 'zh';

    return urlParams.tableId && urlParams.blockId ? (
      <IntlProvider locale={locale} messages={localeMessages[locale]} textComponent="span">
        <Toast
          buttonTitleId={toast ? toast.buttonTitleId : undefined}
          onClick={toast ? toast.onClick : undefined}
          icon={toast && toast.isError ? 'error' : undefined}
          open={toast !== null}
          position={{ left: 24, bottom: 24 }}
        >
          <Context>
            {toast !== null &&
              (toast.messageId ? (
                <FormattedMessage id={toast.messageId} values={toast.values} />
              ) : (
                toast.message || ''
              ))}
          </Context>
        </Toast>
        <TemplatePage urlParams={urlParams} />
      </IntlProvider>
    ) : (
      <div>invalid IDs</div>
    );
  }
}

const mapState = ({ core }: IRootState) => ({
  toast: core.toast,
  currentBlockId: core.currentBlockId,
});
const mapDispatch = ({ core }: IDispatch) => ({
  setIsExpand: core.setIsExpand,
  setLocale: core.setLocale,
  setCurrentBlock: core.setCurrentBlock,
  setCurrentWorkspace: core.setCurrentWorkspace,
  setMeId: core.setMe,
  setCanEdit: core.setCanEdit,
});

export default connect(
  mapState,
  // @ts-ignore
  mapDispatch,
)(App);
